import { Image } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Body } from "capitalrx-components-2.0/lib/typography";

import styles from "./WhiteLabelFooter.module.scss";
import { getBrandLogo, getBrandName } from "@/utils/branding";

export const Footer = () => {
  return (
    <Shelf alignment="center" className={styles.WhiteLabelFooter}>
      <div role="img" aria-label="client logo" className={styles["LogoImage"]} />
      <Body size="small" className={styles.WhiteLabelFooterText}>Powered by <Image src={getBrandLogo()} alt={`${getBrandName()} Logo`} /></Body>
    </Shelf>
  );
};
